import { successType } from "redux-api-status";
import initialState from "./initialState";
import * as types from "../actions/actionTypes";

export default function clientReducer(state = initialState.client, action) {
  switch (action.type) {
    case successType(types.LOAD_CLIENTS):
      return { ...state, List: action.payload.data };
    case successType(types.LOAD_CLIENT):
      const Client = action.payload.data;
      return {
        ...state,
        Profile: Client,
        Contacts: Client.client_clientUsers,
        Documents: Client.clientGuideDocuments,
        History: [],
      };
    case successType(types.LOAD_CLIENT_HISTORY):
      return {
        ...state,
        History: action.payload.data,
      };
    case successType(types.LOAD_CLIENT_PERMANENTVACANCIES):
      return {
        ...state,
        PermanentVacancies: action.payload.data,
      };

    case successType(types.LOAD_CLIENT_BOOKINGS):
      return {
        ...state,
        Bookings: action.payload.data,
      };
    case successType(types.LOAD_CLIENTS_ALL):
      return {
        ...state,
        All: action.payload.data,
      };
    case successType(types.LOAD_CLIENTUSERS_ALL):
      return {
        ...state,
        AllClientUsers: action.payload.data,
      };
    case successType(types.LOAD_CLIENT_CLIENTPREFERENCES):
      return {
        ...state,
        CandidatePreferences: action.payload.data,
      };
    case successType(types.LOAD_CLIENTGUIDE_DOCUMENTS):
      return {
        ...state,
        Documents: action.payload.data,
      };
    case successType(types.LOAD_CLIENTUSERS):
      return {
        ...state,
        Contacts: action.payload.data,
      };
    case successType(types.LOAD_CLIENTUSER_CHAT):
      return {
        ...state,
        CurrentClientUserChat: action.payload.data.reverse(),
      };

    case successType(types.LOAD_CLIENT_CANDIDATEAVAILABILITY):
      return {
        ...state,
        CurrentClientCandidateAvailability: action.payload.data,
      };

    default:
      return state;
  }
}
